import React from 'react';
import styles from './FooterContent.module.scss';

type FooterContentProps = {
  children: React.ReactNode | React.ReactNode[];
};

export const FooterContent = ({ children }: FooterContentProps) => <div className={styles.root}>{children}</div>;
